/**
 * Counts outstanding layer loads and shows/hides the #mapLoader spinner.
 */
export class MapLoadingIndicator {

    private _loadingCount = 0;

    public onLayerLoading = (): void => {
        this._loadingCount += 1;
        $("#mapLoader").show();
    }

    public onLayerLoaded = (): void => {
        //clamp at zero: an unmatched decrement (e.g. an error without a matching
        //load start) must not drive the count negative, or === 0 never matches
        //again and the spinner sticks forever.
        this._loadingCount = Math.max(0, this._loadingCount - 1);
        if (this._loadingCount <= 0) {
            $("#mapLoader").hide("slow");
        }
    }
}
